import type {HelpFile} from '../../types/help'
import {WizardStepBasicsTestIds} from '../../../testids/WizardStepBasicsTestIds'

export const wizardStepBasicsHelp: HelpFile = {
    docPage: '/docs/governance/certification-policies',
    texts: {
        [WizardStepBasicsTestIds.inputPolicyName]:
            'Unique policy name displayed in campaign lists.',
        [WizardStepBasicsTestIds.inputPolicyDescription]: null,
        [WizardStepBasicsTestIds.inputPolicyPriority]:
            'Controls ordering when multiple policies match the same assignment. Lower values are evaluated first.',
        [WizardStepBasicsTestIds.checkboxPolicyActive]: null,
        [WizardStepBasicsTestIds.datepickerValidFrom]:
            'Optional active date window — before this date the policy is inactive.',
        [WizardStepBasicsTestIds.datepickerValidTo]:
            'Optional active date window — after this date the policy is inactive.',
        [WizardStepBasicsTestIds.errorValidTo]: null,
    },
}
